<section class="trending-section" *ngIf="trendingSearchList?.length || trendingAuthorities?.length || trendingStates?.length ||
trendingCities?.length || trendingKeywords?.length">

  <h3 *ngIf="trendingSearchList?.length">Trending Searches</h3>
  <div class="mobile-card-overflow overflow-scroll-1 mb-10" *ngIf="trendingSearchList?.length">
    <div class="mobile-card-row">
      <div *ngFor="let authdata of trendingSearchList" class="card-8">
        <a (click)="navigate($event, authdata.searchUrl)">
          <div class="card-body p-0">
            <h4 class="hover-underline" title="{{authdata?.searchTerm}} Tenders"><a style="color: #0062ff;"
                [href]="baseUrl + '/' + authdata.searchUrl"> {{authdata?.searchTerm}} Tenders </a></h4>
            <p>{{authdata?.searchVolume | indianNumber}} Searches</p>
          </div>
        </a>
      </div>
    </div>
  </div>

  <h3 *ngIf="trendingAuthorities?.length">Top 5 Authorities for {{formattedValue}}</h3>
  <div class="mobile-card-overflow overflow-scroll-1 mb-10" *ngIf="trendingAuthorities?.length">
    <div class="mobile-card-row">
      <div *ngFor="let authdata of trendingAuthorities" class="card-8">
        <div class="card-body p-0" (click)="navigateToTenders(authdata.link); $event.preventDefault()">
          <h4 class="hover-underline" title="{{authdata?.name}} Tenders"><a style="color: #0062ff;"
              [href]="baseUrl + '/' + authdata.link + '-tenders/active'"> {{authdata?.name}} Tenders</a></h4>
          <p>{{authdata?.count}} Tenders</p>
        </div>
      </div>
    </div>
  </div>

  <h3 *ngIf="trendingStates?.length">Top 5 States for {{formattedValue}}</h3>
  <div class="mobile-card-overflow overflow-scroll-1 mb-10" *ngIf="trendingStates?.length">
    <div class="mobile-card-row">
      <div *ngFor="let authdata of trendingStates" class="card-8">
        <div class="card-body p-0" (click)="navigateToTenders(authdata.link); $event.preventDefault()">
          <h4 class="hover-underline" title="{{authdata?.name}} Tenders"><a style="color: #0062ff;"
              [href]="baseUrl + '/' + authdata.link + '-tenders/active'"> {{authdata?.name}} Tenders</a></h4>
          <p>{{authdata?.count}} Tenders</p>
        </div>
      </div>
    </div>
  </div>

  <h3 *ngIf="trendingCities?.length">Top 5 Cities for {{formattedValue}}</h3>
  <div class="mobile-card-overflow overflow-scroll-1 mb-10" *ngIf="trendingCities?.length">
    <div class="mobile-card-row">
      <div *ngFor="let authdata of trendingCities" class="card-8">
        <div class="card-body p-0" (click)="navigateToTenders(authdata.link); $event.preventDefault()">
          <h4 class="hover-underline" title="{{authdata?.name}} Tenders"><a style="color: #0062ff;"
              [href]="baseUrl + '/' + authdata.link + '-tenders/active'"> {{authdata?.name}} Tenders</a></h4>
          <p>{{authdata?.count}} Tenders</p>
        </div>
      </div>
    </div>
  </div>

  <h3 *ngIf="trendingKeywords?.length">Top 5 Keywords for {{formattedValue}}</h3>
  <div class="mobile-card-overflow overflow-scroll-1" *ngIf="trendingKeywords?.length">
    <div class="mobile-card-row">
      <div *ngFor="let authdata of trendingKeywords" class="card-8">
        <div class="card-body p-0" (click)="navigateToTenders(authdata.link); $event.preventDefault()">
          <h4 class="hover-underline" title="{{authdata?.name}} Tenders"><a style="color: #0062ff;"
              [href]="baseUrl + '/' + authdata.link + '-tenders/active'"> {{authdata?.name}} Tenders</a></h4>
          <p>{{authdata?.count}} Tenders</p>
        </div>
      </div>
    </div>
  </div>
</section>